import { render, staticRenderFns } from "./MyShops.vue?vue&type=template&id=9d1757c8"
import script from "./MyShops.vue?vue&type=script&lang=js"
export * from "./MyShops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports